module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/bonus-pict-6c705d54a05eaf9fff782811ae366041.jpg";